import React, { useState, useEffect, useContext } from 'react'
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Button from 'react-bootstrap/Button';
import ListGroup from 'react-bootstrap/ListGroup';
import { FaRegTrashAlt } from 'react-icons/fa';
import { BsDot } from 'react-icons/bs';
import { ObjModal } from '../../../../contexts';
import AddTask from '../../../Modals/AddTask';

import { styled } from '@mui/material/styles';
import Accordion from '@mui/material/Accordion';
import AccordionDetails from '@mui/material/AccordionDetails';
import Typography from '@mui/material/Typography';
import KeyboardArrowRightSharpIcon from '@mui/icons-material/KeyboardArrowRightSharp';
import MuiAccordionSummary from '@mui/material/AccordionSummary';
import { monthsShort } from '../../../../common/utils';
import { removeTask } from '../../../../common/api';
import { toast } from 'react-toastify';


const Tasks = ( { aid, uid, settings } ) => {
    const { objType, obj, openModal, closeModal, setModal } = useContext( ObjModal );
    const [ expanded, setExpanded ] = useState( false );

    const trash = async ( taid, tid ) => {
        const removed = await removeTask( taid, uid, tid );
        if ( removed.length ) {
            toast.success( 'The task has been deleted', { theme: 'dark' } );
            // window.location.reload( false );
        }
    };

    const handleModal = ( t ) => {
        let shouldOpen = true;

        switch ( t ) {
            case 'task':
                if ( objType === 'contact' ) {
                    setModal( <AddTask close={closeModal} aid={obj.details.aid} cid={obj.details.cid} /> ); 
                } else if ( objType === 'loan' ) {
                    let cid;
                    if ( obj.borrowers && obj.borrowers.length ) {
                        cid = obj.borrowers[0].cid;
                    }
                    setModal( <AddTask close={closeModal} aid={obj.details.aid} cid={cid} lid={obj.details.lid} /> ); 
                }
                break;

            default:
                console.log( 'Unknown modal type: ' + t );
                shouldOpen = false;
        }

        if ( shouldOpen ) {
            openModal();
        }
    }

    const formatDate = ( d ) => {
        if ( d ) {
            const [ yr, mon, dd ] = d.replace( /[T\s].*/, '' ).split( '-' );
            return `${monthsShort[parseInt(mon) - 1]} ${dd}, ${yr}`;
        }
        return '';
    }

    const formatTaskDate = ( t ) => {
        if ( t.status === 'Completed' ) {
            if ( t.completedDate ) {
                return formatDate( t.completedDate );
            } else {
                return formatDate( t.lastUpdatedDate );
            }
        }
        if ( t.status === 'Cancelled' ) {
            if ( t.cancelled ) {
                return formatDate( t.cancelledDate );
            } else {
                return formatDate( t.lastUpdatedDate );
            }
        }

        return formatDate( t.dueDate );
    }

    const sortTasks = ( a, b ) => {
        let ad = Date.parse( a.dueDate );
        let bd = Date.parse( b.dueDate );
        
        if ( a.status === 'Completed' ) {
            if ( a.completedDate ) {
                ad = Date.parse( a.completedDate );
            } else {
                ad = Date.parse( a.lastUpdatedDate );
            }
        }
        if ( a.status === 'Cancelled' ) {
            if ( a.cancelledDate ) {
                ad = Date.parse( a.cancelledDate );
            } else {
                ad = Date.parse( a.lastUpdatedDate );
            }
        }
        if ( b.status === 'Completed' ) {
            if ( b.completedDate ) {
                bd = Date.parse( b.completedDate );
            } else {
                bd = Date.parse( b.lastUpdatedDate );
            }
        }
        if ( b.status === 'Cancelled' ) {
            if ( b.cancelledDate ) {
                bd = Date.parse( b.cancelledDate );
            } else {
                bd = Date.parse( b.lastUpdatedDate );
            }
        }
        if ( settings?.task?.sidebar?.sort === 'due-desc' ) {
            return bd - ad;
        }

        if ( a.status === 'Completed' && b.status === 'Completed' ) {
            // both completed - show most recent first
            return bd - ad;
        }
        if ( a.status === 'Completed' ) {
            return 1;
        }
        if ( b.status === 'Completed' ) {
            return -1;
        }
        
        return ad - bd;
    }

    const AccordionSummary = styled( ( props ) => (
        <MuiAccordionSummary expandIcon={<KeyboardArrowRightSharpIcon sx={{ fontSize: '0.9rem' }} />} {...props} />
    ) ) ( ( { theme } ) => ( {
        backgroundColor:
          theme.palette.mode === 'dark'
            ? 'rgba(255, 255, 255, .05)'
            : 'rgba(0, 0, 0, .03)',
        flexDirection: 'row-reverse',
        '& .MuiAccordionSummary-expandIconWrapper.Mui-expanded': {
            transform: 'rotate(90deg)',
        },
        '& .MuiAccordionSummary-content': {
            marginLeft: theme.spacing(1),
        },
    } ) );

    useEffect( () => {
        setExpanded( obj.tasks.length > 0 );
    }, [ obj.tasks ] );
    
    return (
        <Container fluid className='p-0'>
            <Accordion expanded={expanded}>
                <AccordionSummary expandIcon={<KeyboardArrowRightSharpIcon onClick={ () => setExpanded( !expanded ) } />}>
                    <Row className='align-items-center w-100'>
                        <Col><Typography>Tasks ({obj.tasks.length})</Typography></Col>
                        <Col xs='auto' className='p-0'><Button variant='outline-primary' size='sm' onClick={ () => handleModal( 'task' ) }>+ Add</Button></Col>
                    </Row>
                </AccordionSummary>
                <AccordionDetails>
                    <ListGroup variant='flush' className='overflow-scroll' style={ { maxHeight: '250px' } }>
                    { obj.tasks.sort( sortTasks ).map( ( t, idx ) => (
                        <ListGroup.Item key={idx}>
                            <Row className='align-items-center'>
                                <Col xs='auto' className='tf-sidebar-obj-value'>
                                    {t.status}
                                </Col>
                                <Col>
                                    <Row>
                                        <Col xs='auto' className='p-1 ps-3 pb-0'>
                                            <Link to={`/task/${t.tid}`}>{t.name}</Link>
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col xs='auto' className='p-1 ps-3 pt-0'>
                                            {/* { ![ 'Completed', 'Cancelled' ].includes( t.status ) ? formatDate( t.dueDate ) : formatDate( t.completedDate ) } */}
                                            {formatTaskDate( t )}
                                        </Col>
                                        <Col xs='auto' className='p-0'><BsDot /></Col>
                                        <Col xs='auto' className='p-1 pt-0'>{t.assignedTo}</Col>
                                    </Row>
                                </Col>
                                <Col xs='auto'><FaRegTrashAlt className='tf-sidebar-trash' onClick={ () => trash( t.aid, t.tid ) } /></Col>
                            </Row>
                            {
                                ( [ 'Completed', 'Cancelled' ].includes( t.status ) && t.outcome ) ? (
                                    <Row className='overflow-scroll' style={ { maxHeight: '200px' } }>    
                                        <Col dangerouslySetInnerHTML={ { __html: t.outcome } } />
                                    </Row>
                                ) : (
                                    null
                                )
                            }
                        </ListGroup.Item>
                    ) ) }
                    </ListGroup>
                </AccordionDetails>
            </Accordion>
        </Container>
    )
}

const mapProps = ( state ) => ( {
    aid: state.user.aid,
    uid: state.user.email,
    settings: state.user.meta.settings
} );
  
const mapDispatch = ( dispatch ) => ( {
    // loadTasks: dispatch.contacts.loadContactTasks,
} );
  
export default connect( mapProps, mapDispatch )( Tasks );